export const smartDocStaticParamType_MDM_ProtocolType_CC = 'chief-complaint';
export const smartDocStaticParamType_MDM_ProtocolType_DD = 'differential-diagnosis';
export const smartDocStaticParamType_MDM_ProtocolType_TT = 'treatment';
export const smartDocStaticParamType_MDM_ProtocolType_TR = 'triage';
export const smartDocStaticParamType_MDM_ProtocolType_SS = 'single-state';
export const smartDocStaticParamType_MDM_ProtocolType_OS = 'order-set';
export const smartDocStaticParamType_MDM_ProtocolTypes = [
    smartDocStaticParamType_MDM_ProtocolType_CC,
    smartDocStaticParamType_MDM_ProtocolType_DD,
    smartDocStaticParamType_MDM_ProtocolType_TT,
    smartDocStaticParamType_MDM_ProtocolType_TR,
    smartDocStaticParamType_MDM_ProtocolType_SS,
    smartDocStaticParamType_MDM_ProtocolType_OS,
];
export const smartDocStaticParamType_MDM_ConsiderationGroup_High = 'high_consideration';
export const smartDocStaticParamType_MDM_ConsiderationGroup_Low = 'low_consideration';
export const smartDocStaticParamType_MDM_ConsiderationGroup_BelowThreshold = 'below_threshold';
export const smartDocStaticParamType_MDM_ConsiderationGroups = [
    smartDocStaticParamType_MDM_ConsiderationGroup_High,
    smartDocStaticParamType_MDM_ConsiderationGroup_Low,
    smartDocStaticParamType_MDM_ConsiderationGroup_BelowThreshold,
];
export const smartDocStaticParamType_MDM_ProtocolStatus_Navigating = 'states_navigating';
export const smartDocStaticParamType_MDM_ProtocolStatus_Initialized = 'initialized';
export const smartDocStaticParamType_MDM_ProtocolStatus_ReachedAdmit = 'reached_admit';
export const smartDocStaticParamType_MDM_ProtocolStatus_ReachedDischarge = 'reached_discharge';
export const smartDocStaticParamType_MDM_ProtocolStatus_ReachedReassessment = 'reached_reassessment';
export const smartDocStaticParamType_MDM_ProtocolStatus_CCProtocolEnd = 'reached_cc_protocol_end';
export const smartDocStaticParamType_MDM_ProtocolStatus_SSProtocolEnd = 'reached_ss_protocol_end';
export const smartDocStaticParamType_MDM_ProtocolStatus_OSProtocolEnd = 'reached_os_protocol_end';
export const smartDocStaticParamType_MDM_ProtocolStatus = [
    smartDocStaticParamType_MDM_ProtocolStatus_Navigating,
    smartDocStaticParamType_MDM_ProtocolStatus_Initialized,
    smartDocStaticParamType_MDM_ProtocolStatus_ReachedAdmit,
    smartDocStaticParamType_MDM_ProtocolStatus_ReachedDischarge,
    smartDocStaticParamType_MDM_ProtocolStatus_ReachedReassessment,
    smartDocStaticParamType_MDM_ProtocolStatus_CCProtocolEnd,
    smartDocStaticParamType_MDM_ProtocolStatus_SSProtocolEnd,
    smartDocStaticParamType_MDM_ProtocolStatus_OSProtocolEnd,
];
export const smartDocStaticParamType_MDM = 'mdm';
//# sourceMappingURL=types.js.map